export default "__VITE_ASSET__yn7yc7Z$__"